var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgMilestone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.54044 9.87377L9.87377 1.54044C9.94348 1.47073 10.0565 1.47073 10.1262 1.54044L18.4596 9.87377C18.5293 9.94349 18.5293 10.0565 18.4596 10.1262L10.1262 18.4596C10.0565 18.5293 9.94348 18.5293 9.87377 18.4596L1.54044 10.1262C1.47073 10.0565 1.47073 9.94349 1.54044 9.87377Z",
    stroke: "#78a9ff",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.1421,
    height: 14.1421,
    fill: "white",
    transform: "translate(0 10) rotate(-45)"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgMilestone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/milestone.0bb303acf71ced9497d3e565ecc0ab0a.svg";